var render = function render(){
  var _vm$crntTag;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "tagAddListWrap",
    class: _vm.tagOptionPopAddListViewBln ? 'active' : null,
    on: {
      "click": _vm.closeHandler
    }
  }, [_c('section', {
    ref: "tagAddListWrap",
    staticClass: "contentWrap"
  }, [_c('h2', [_vm._v(_vm._s((_vm$crntTag = _vm.crntTag) === null || _vm$crntTag === void 0 ? void 0 : _vm$crntTag.name) + "명 입력")]), _c('InputSrchWrap'), _c('SrchList'), _c('button', {
    staticClass: "closeBtn",
    on: {
      "click": function ($event) {
        _vm.setTagOptionPopAddListViewBln({
          bln: false
        });

        _vm.setCallbackFunc(null);
      }
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 14 14",
      "fill": "none"
    }
  }, [_c('path', {
    attrs: {
      "d": "M1.4 14L0 12.6L5.6 7L0 1.4L1.4 0L7 5.6L12.6 0L14 1.4L8.4 7L14 12.6L12.6 14L7 8.4L1.4 14Z",
      "fill": "#333333"
    }
  })]), _c('span', [_vm._v("닫기")])])], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }